import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, TextField } from '@material-ui/core';

const CurrencySelectSearchfield = ({ onChange, label }) => (
  <FormControl fullWidth>
    <TextField
      id="search"
      label={label}
      type="search"
      margin="normal"
      onChange={onChange}
      fullWidth
      autoFocus
      autoComplete="off"
    />
  </FormControl>
);

CurrencySelectSearchfield.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

CurrencySelectSearchfield.defaultProps = {
  label: 'Währung oder Land suchen',
};

export default (CurrencySelectSearchfield);



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelectSearchfield.js